import React from "react";
import { useWorkspace } from "../../context/WorkspaceRegionProvider";
import CnHome from "../home";
import IntlHome from "../intl/Home";

const WorkspaceHome = () => {
  const { workspace } = useWorkspace();

  if (workspace === "intl") {
    return <IntlHome key={workspace} />;
  }

  return <CnHome key={workspace} />;
};

export default WorkspaceHome;
